export enum INSTALLMENT_STATUS_ENUM {
  WAITING_PAYMENT = 'PENDENTE',
  CANCELED = 'CANCELADO',
  REFUNDED = 'ESTORNADO',
  PAID = 'PAGO',
  WAITING_REPASS = 'PAGO',
  NOTPAID = 'NĀO PAGO',
  ERROR_SUBSCRIPTION = 'VENCIDO',
}
